import React from 'react';
import { Canvas } from 'react-three-fiber';
import Model from './Model';
import Chatbot from './chatbot';
import AudioPlayer from './Audio';

function CreativeView() {
  return (
    <div
      style={{
        background: '#191919',
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      <AudioPlayer />
      <div
        style={{
          width: '40%',
          height: '50vh'
        }}
        className='creative-view'
      >
        <Canvas>
          <ambientLight />
          <pointLight position={[10, 10, 10]} />
          <Model />
        </Canvas>
      </div>
      <Chatbot />
    </div>
  );
}

export default CreativeView;
